const menuList = [
  { title: 'message.layout.dashboard', icon: 'mdi-gauge', to: '/dashboard' },
  { title: 'message.layout.crm', icon: 'assignment_ind', to: '/customers' },
  { title: 'message.layout.employees', icon: 'account_circle', to: '/users' },
  { title: 'message.layout.order', icon: 'add_shopping_cart', to: '/orders' },
  { title: 'message.layout.warehouse', icon: 'business', to: '/w_h/stocks' },
  { title: 'message.layout.productionOrder', icon: 'shopping_cart', to: '/production_order/order' },
  { title: 'message.layout.reports', icon: 'schedule', to: '/reports' },
  { title: 'message.layout.deviation', icon: 'trending_up', to: '/deviations' },
  {
    title: 'message.layout.crmSettings',
    icon: 'mdi-account-settings',
    isSettings: true,
    hasChildren: true,
    children: [
      { title: 'message.layout.category', icon: 'mdi-marker-check', to: '/crm_priorities' },
      { title: 'message.layout.shipments', icon: 'mdi-truck-delivery', to: '/crm_shipments' },
      { title: 'message.layout.industries', icon: 'mdi-factory', to: '/crm_industries' }
    ]
  },
  // { title: 'message.layout.userRole', icon: 'layers', to: '/user_roles' },
  // { title: 'message.layout.permission', icon: 'fingerprint', to: '/permissions' },
  { title: 'message.layout.currencies', icon: 'mdi-currency-eur', to: '/currencies' },
  { title: 'message.layout.salesAccounts', icon: 'mdi-sale', to: '/salesaccounts' },
  { title: 'message.layout.tools', icon: 'build', to: '/tools' },
  {
    title: 'message.layout.products',
    icon: 'mdi-package-variant-closed',
    hasChildren: true,
    children: [
      { title: 'message.layout.workFlow', icon: 'shutter_speed', to: '/product_workflow' },
      { title: 'message.layout.WorkFlowStates', icon: 'mdi-google-circles-extended', to: '/workflow_states' },
      { title: 'message.layout.productGroup', icon: 'wysiwyg', to: '/product_groups' },
      { title: 'message.layout.department', icon: 'mdi-format-list-checks', to: '/department' },
      { title: 'message.layout.productUnit', icon: 'business_center', to: '/product_units' },
      { title: 'message.report.productClass', icon: 'view_quilt', to: '/product_class' }
    ]
  },
  {
    title: 'message.layout.deviations',
    icon: 'mdi-chart-line-stacked',
    hasChildren: true,
    children: [
      { title: 'message.layout.category', icon: 'mdi-equal-box', to: '/deviation_category' },
      { title: 'message.layout.location', icon: 'mdi-map-marker-plus', to: '/deviation_location' },
      { title: 'message.layout.status', icon: 'mdi-widgets', to: '/deviation_status' }
    ]
  },
  {
    title: 'message.layout.sharepointSetting',
    icon: 'mdi-microsoft-sharepoint',
    to: '/sharepoint'
  },
  {
    title: 'message.layout.warehouse',
    icon: 'mdi-warehouse',
    hasChildren: true,
    children: [
      { title: 'message.layout.warehouse', icon: 'mdi-warehouse', to: '/settings/warehouse' },
      { title: 'message.layout.warehouseLocations', icon: 'mdi-map-marker', to: '/warehouse_location' },
      { title: 'message.layout.grossMargin', icon: 'mdi-chart-bar-stacked', to: '/grossmargins' }
      // { title: 'message.layout.discountGroups', icon: 'mdi-percent', to: '/discountgroups' }
    ]
  },
  {
    title: 'message.layout.checklist',
    icon: 'mdi-note-text',
    hasChildren: true,
    children: [
      { title: 'Templates', icon: 'mdi-equal-box', to: '/checklist_templates' },
      { title: 'Properties', icon: 'mdi-marker-check', to: '/properties' }
    ]
  }
]
export default menuList
